import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import {
  ParametrosOrdenamientosEntity,
  ServicioOrdenamientosService,
  FiltrosOrdenGeneralEntity,
  OrdenesGeneralEntity,
  DatosGeneralesEntity,
  InfoOrdenamientoEntity
} from 'src/app/services/servicio-ordenamientos.service';
import { ActivatedRoute } from '@angular/router';
import { ServicioEntidadService, EntidadEmpresarialEntity } from 'src/app/services/servicio-entidad.service';
import { ImagesService } from 'src/app/services/utils/images.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reporte-orden-general',
  templateUrl: './reporte-orden-general.component.html',
  styleUrls: ['./reporte-orden-general.component.css']
})
export class ReporteOrdenGeneralComponent implements OnInit {

  datosGenerales: DatosGeneralesEntity;
  filtros: FiltrosOrdenGeneralEntity;
  parametros: ParametrosOrdenamientosEntity = {} as ParametrosOrdenamientosEntity;
  ordenesGeneral: OrdenesGeneralEntity[] = [];
  entidadEmpresarial: EntidadEmpresarialEntity;
  infoOrdenamiento: InfoOrdenamientoEntity;

  now = new Date();
  mensajeLoading: string = 'Cargando...';
  mensajeError: string;
  logo: string;

  constructor(private activatedRoute: ActivatedRoute,
    private ordenamientosService: ServicioOrdenamientosService,
    private servicioEntidad: ServicioEntidadService,
    private servicioImagenes: ImagesService,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.parametros.codigo = params['codigoBaseDatos'];
      this.parametros.uncoSede = Number(params['uncoSede']);
      this.parametros.uncoLogin = Number(params['uncoLogin']);
      this.parametros.unco = Number(params['uncoAdmision']);
      this.parametros.uncoTransaccion = Number(params['uncoTransaccion']);
      this.parametros.uncoHc = Number(params['uncoHc']);
    });
  }

  ngOnInit() {
    this.getLogo();
  }

  onFiltrosCompletados(filtros: FiltrosOrdenGeneralEntity) {
    this.filtros = filtros;
    this.getOrdenesGeneral();
  }

  async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información del logo entidad ...';
      const response = await this.servicioImagenes.getLogo(this.parametros.codigo);
      response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenGeneralComponent.getLogo()', err);
        this.onError('Error al obtener información del logo entidad, verifique su conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenGeneralComponent.getLogo()', e);
      this.onError('Error grave al obtener información del logo entidad, intente de nuevo o reporte caso al administrador.');
    }
  }

  async getEntidadEmpresarial() {
    try {
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.parametros.codigo, this.parametros.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        if (data && data.length > 0) {
          this.entidadEmpresarial = data[0];
          this.mensajeLoading = null;
          this.mensajeError = null;
        } else {
          this.onError('No se pudo cargar la información de la entidad empresarial. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenGeneralComponent.getEntidadEmpresarial()', err);
        this.onError('Error al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenGeneralComponent.getEntidadEmpresarial()', e);
      this.onError('Error grave al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getOrdenesGeneral() {
    try {
      this.mensajeLoading = 'Cargando ordenes ...';
      const profesionales = this.filtros.profesionales.toString();
      const response = await this.ordenamientosService.getOrdenesGeneral(this.parametros, profesionales);
      response.subscribe((data: any) => {
        if (data && data['#result-set-1']) {
          this.ordenesGeneral = this.ordenamientosService.getOrdenesGeneralEntity(data['#result-set-1']);
          this.getInfoAdicionalOrdenamiento()
        } else {
          this.onError('No se pudo cargar la información de las ordenes. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenGeneralComponent.getOrdenesGeneral()', err);
        this.onError('Error al obtener información de las ordenes, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenGeneralComponent.getOrdenesGeneral()', e);
      this.onError('Error grave al obtener información de las ordenes, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getInfoAdicionalOrdenamiento() {
    try {
      const response = await this.ordenamientosService.getInfoAdicionalOrdenamiento(this.parametros,
        this.filtros.profesionales[0]);
      response.subscribe((data: any) => {
        if (data && data['diasValidez']) {
          this.infoOrdenamiento = this.ordenamientosService.getInfoOrdenamientoEntity(data);
          this.getDatosGenerales();
        } else {
          this.onError('No se pudo cargar la información de las ordenes. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicamentosComponent.getInfoAdicionalOrdenamiento()', err);
        this.onError('Error al obtener información de las ordenes, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicamentosComponent.getInfoAdicionalOrdenamiento()', e);
      this.onError('Error grave al obtener información de las ordenes, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getDatosGenerales() {
    try {
      this.mensajeLoading = 'Cargando datos generales ...';
      let response = await this.ordenamientosService.getDatosGenerales(this.parametros);
      response.subscribe((data: object) => {
        const result = data['#result-set-1'];
        if (result && result.length > 0) {
          this.datosGenerales = this.ordenamientosService.getDatosGeneralesEntity(result);
          this.mensajeLoading = null;
          this.mensajeError = null;
        } else {
          this.onError('Ocurrió un error al cargar la información del afiliado, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
        }
      }, (error) => {
        console.log('Error ReporteOrdenEscritasComponent.getDatosGenerales()', error);
        this.onError('Ocurrió un error al cargar la información del afiliado, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenEscritasComponent.getDatosGenerales()', e);
      this.onError('Error grave al obtener información del afiliado, intente de nuevo o reporte caso al administrador.');
    }
  }

  getDescripcionDiagnostico(key: 'diagnostico' | 'diagnosticoRel1' | 'diagnosticoRel2') {
    let descripcionDiagn = '--';
    if (this.infoOrdenamiento && this.infoOrdenamiento[key]) {
      const { descripcion, codigoDiagnostico, activaDescripcion } = this.infoOrdenamiento[key];
      if (activaDescripcion) {
        descripcionDiagn = `(${codigoDiagnostico}) ${descripcion}`;
      } else {
        if (codigoDiagnostico !== undefined && codigoDiagnostico.trim().length > 0) {
          descripcionDiagn = `(${codigoDiagnostico})`
        }
      }
    }
    return descripcionDiagn;
  }

  getEdad() {
    return Math.floor(moment(new Date()).diff(moment(this.datosGenerales.fechaNac, 'MM/DD/YYYY'),
      'years', true)) + " Año(s)";
  }

  onErrorGenerado(mensajeError: string) {
    this.mensajeError = mensajeError;
  }

  onError(msj) {
    this.mensajeLoading = null;
    this.mensajeError = msj;
  }

  isLoading(): boolean {
    return this.mensajeLoading && this.mensajeLoading.length > 0
      && !this.isError();
  }

  isError(): boolean {
    return this.mensajeError && this.mensajeError.length > 0;
  }

  isReady(): boolean {
    return !this.isLoading() && !this.isError();
  }

}
